export default __webpack_public_path__ + "static/media/Razzo-rosso.af14f3b2.svg";